import { useState } from "react";
import { Tooltip } from "antd";
import { CopyOutlined, CheckOutlined } from "@ant-design/icons";

interface CopyButtonProps {
  value?: string | number | null;
  size?: number;
  style?: React.CSSProperties;
}

const CopyButton: React.FC<CopyButtonProps> = ({ value, size = 12, style }) => {
  const [copied, setCopied] = useState(false);

  if (value === undefined || value === null || value === "") return null;

  const handleCopy = (e: React.MouseEvent) => {
    e.stopPropagation();
    e.preventDefault();
    navigator.clipboard.writeText(String(value)).then(() => {
      setCopied(true);
      setTimeout(() => setCopied(false), 1200);
    });
  };

  return (
    <Tooltip title={copied ? "Copied!" : "Copy"}>
      <span
        role="button"
        onClick={handleCopy}
        style={{
          cursor: "pointer",
          marginLeft: 6,
          color: copied ? "#52c41a" : "#8c8c8c",
          fontSize: size,
          display: "inline-flex",
          verticalAlign: "middle",
          ...style,
        }}
      >
        {copied ? <CheckOutlined /> : <CopyOutlined />}
      </span>
    </Tooltip>
  );
};

export default CopyButton;
